import React, { useEffect, useRef } from 'react'
import mermaid from 'mermaid'

interface MermaidDiagramProps {
  chart: string
}

const MermaidDiagram: React.FC<MermaidDiagramProps> = ({ chart }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    // Initialize Mermaid once
    mermaid.initialize({ startOnLoad: false })

    // Use a unique ID for each render
    const renderId = `mermaid-${Math.floor(Math.random() * 100000)}`

    mermaid
      .render(renderId, chart)
      .then(({ svg }) => {
        if (containerRef.current) {
          containerRef.current.innerHTML = svg
        }
      })
      .catch((err: unknown) => {
        console.error('Mermaid render error:', err)
      })
  }, [chart])

  return <div ref={containerRef} />
}

export default MermaidDiagram
